// Servicio de datos que permite alternar entre Mock Data y Firebase
import { 
  firebaseWinesService, 
  firebaseCategoriesService, 
  firebaseWineriesService, 
  firebaseTypesService
} from './firebaseService';
import initializeFirebaseCollections from '../scripts/initFirebaseCollections';
import { 
  mockWinesApi, 
  mockCategoriesApi, 
  mockWineriesApi, 
  mockTypesApi 
} from './mockData';

// Configuración: cambia a true para usar Firebase, false para usar mock data
const USE_FIREBASE = true;

console.log(`🔥 Data Service: Using ${USE_FIREBASE ? 'Firebase' : 'Mock Data'}`);

// Inicializar colecciones de Firebase automáticamente
if (USE_FIREBASE) {
  initializeFirebaseCollections().catch(console.error);
}

// Servicio unificado para vinos
export const winesService = {
  getAll: async () => {
    return USE_FIREBASE ? firebaseWinesService.getAll() : mockWinesApi.getAll();
  },
  create: async (formData) => {
    return USE_FIREBASE ? firebaseWinesService.create(formData) : mockWinesApi.create(formData);
  },
  update: async (id, formData) => {
    return USE_FIREBASE ? firebaseWinesService.update(id, formData) : mockWinesApi.update(id, formData);
  },
  delete: async (id) => {
    return USE_FIREBASE ? firebaseWinesService.delete(id) : mockWinesApi.delete(id);
  }
};

// Servicio unificado para categorías
export const categoriesService = {
  getAll: async () => {
    return USE_FIREBASE ? firebaseCategoriesService.getAll() : mockCategoriesApi.getAll();
  },
  create: async (data) => {
    return USE_FIREBASE ? firebaseCategoriesService.create(data) : mockCategoriesApi.create(data);
  },
  update: async (id, data) => {
    return USE_FIREBASE ? firebaseCategoriesService.update(id, data) : mockCategoriesApi.update(id, data);
  },
  delete: async (id) => {
    return USE_FIREBASE ? firebaseCategoriesService.delete(id) : mockCategoriesApi.delete(id);
  }
};

// Servicio unificado para bodegas
export const wineriesService = {
  getAll: async () => {
    return USE_FIREBASE ? firebaseWineriesService.getAll() : mockWineriesApi.getAll();
  },
  create: async (data) => {
    return USE_FIREBASE ? firebaseWineriesService.create(data) : mockWineriesApi.create(data);
  },
  update: async (id, data) => {
    return USE_FIREBASE ? firebaseWineriesService.update(id, data) : mockWineriesApi.update(id, data);
  },
  delete: async (id) => {
    return USE_FIREBASE ? firebaseWineriesService.delete(id) : mockWineriesApi.delete(id);
  }
};

// Servicio unificado para tipos
export const typesService = {
  getAll: async () => {
    return USE_FIREBASE ? firebaseTypesService.getAll() : mockTypesApi.getAll();
  },
  create: async (data) => {
    return USE_FIREBASE ? firebaseTypesService.create(data) : mockTypesApi.create(data);
  },
  update: async (id, data) => {
    return USE_FIREBASE ? firebaseTypesService.update(id, data) : mockTypesApi.update(id, data);
  },
  delete: async (id) => {
    return USE_FIREBASE ? firebaseTypesService.delete(id) : mockTypesApi.delete(id);
  }
};

// Función para cambiar entre Firebase y Mock Data
export const switchToFirebase = () => {
  console.log('🔄 Switching to Firebase...');
  // Recargar la página para aplicar el cambio
  window.location.reload();
};

export const switchToMockData = () => {
  console.log('🔄 Switching to Mock Data...');
  // Recargar la página para aplicar el cambio
  window.location.reload();
};

// Función para obtener el estado actual
export const getCurrentDataSource = () => USE_FIREBASE ? 'firebase' : 'mock';

// Función para inicializar Firebase con datos de ejemplo
export const initFirebaseData = async () => {
  if (USE_FIREBASE) {
    return initializeFirebaseCollections();
  } else {
    console.warn('Firebase is not enabled. Enable it by setting USE_FIREBASE to true.');
  }
}; 